import { render, staticRenderFns } from "./MicrositiosEventos.vue?vue&type=template&id=28a0fa85&"
import script from "./MicrositiosEventos.vue?vue&type=script&lang=js&"
export * from "./MicrositiosEventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/spainhn-web-op/spainhn-web-op/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a0fa85')) {
      api.createRecord('28a0fa85', component.options)
    } else {
      api.reload('28a0fa85', component.options)
    }
    module.hot.accept("./MicrositiosEventos.vue?vue&type=template&id=28a0fa85&", function () {
      api.rerender('28a0fa85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MicrositiosEventos.vue"
export default component.exports